import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { nav, legalNav, assets, contact, home } from "../mock";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0a0908] border-t border-border">
      <div className="container-x py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-3">
              <img src={assets.monogram} alt="Melano International" className="h-12 w-auto" />
            </Link>
            <p className="font-display uppercase tracking-[0.28em] text-foreground mt-4 text-sm">
              Melano International
            </p>
            <p className="text-muted-foreground text-sm mt-3 leading-relaxed max-w-[220px]">
              Honoring vision, for leaders creating a future worth inheriting.
            </p>
          </div>

          {/* Explore */}
          <div>
            <h4 className="eyebrow mb-5">Explore</h4>
            <ul className="space-y-3">
              {nav.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-foreground/80 hover:text-gold transition-colors text-sm">
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Brands */}
          <div>
            <h4 className="eyebrow mb-5">Our Brands</h4>
            <ul className="space-y-3">
              {home.ecosystem.brands.map((b) => (
                <li key={b.id}>
                  {b.link ? (
                    <a
                      href={b.link}
                      target="_blank"
                      rel="noreferrer"
                      className="text-foreground/80 hover:text-gold transition-colors text-sm inline-flex items-center gap-1"
                    >
                      {b.name} <ArrowUpRight size={14} />
                    </a>
                  ) : (
                    <span className="text-foreground/80 text-sm">{b.name}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact + Legal */}
          <div>
            <h4 className="eyebrow mb-5">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={`mailto:${contact.email}`} className="text-foreground/80 hover:text-gold transition-colors">
                  {contact.email}
                </a>
              </li>
              <li>
                <a href={contact.phoneHref} className="text-foreground/80 hover:text-gold transition-colors">
                  {contact.phone}
                </a>
              </li>
              <li className="text-muted-foreground leading-relaxed">{contact.address}</li>
            </ul>
          </div>
        </div>

        {/* Acknowledgement of Country */}
        <div className="mt-14 pt-12 border-t border-border text-center">
          <h4 className="font-display uppercase font-bold tracking-[0.28em] text-sm text-foreground mb-6">
            Acknowledgement of Country
          </h4>
          <p className="font-body text-muted-foreground text-base md:text-lg leading-relaxed max-w-2xl mx-auto font-light">
            We pay deep respect to the original owners of this land and to their descendants who walk softly.
            We bow to their ancestors, and the generations yet to come.
          </p>
        </div>

        <div className="mt-14 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-muted-foreground text-xs tracking-wide">
            © {year} Melano International Pty. Ltd. All rights reserved.
          </p>
          <ul className="flex flex-wrap items-center gap-x-6 gap-y-2">
            {legalNav.map((l) => (
              <li key={l.slug}>
                <Link
                  to={`/legal/${l.slug}`}
                  className="text-muted-foreground hover:text-gold transition-colors text-xs"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
}
